<template>
  <div>
    <div class="row">
      <div class="col-lg-6 col-md-12">
        <div class="card">
          <div class="card-body">
            <div>
              <h3 class="card-title">{{ $t('Personal Data') }}</h3>
            </div>
            <form class="form-horizontal p-t-20">
              <div class="form-group row">



                <div class="col-sm-6">
                  <label for="fname" class="control-label">{{ $t('First name') }}</label>
                  <div class="input-group">
                    <input type="text" class="form-control btn-rounded" id="fname" v-model="userData.firstname">
                  </div>
                </div>

                <div class="col-sm-6">
                  <label for="lname" class="control-label">{{ $t('Last name') }}</label>
                  <div class="input-group">
                    <input type="text" class="form-control btn-rounded" id="lname" v-model="userData.lastname">
                  </div>
                </div>
              </div>

              <div class="form-group row">
                <label for="position" class="col-sm-12 control-label">{{ $t('Position') }}</label>
                <div class="col-sm-12">
                  <div class="input-group">
                    <input type="text" class="form-control btn-rounded" id="position" v-model="userData.position">
                  </div>
                </div>
              </div>

              <div class="form-group row">
                <label for="email" class="col-sm-12 control-label">{{ $t('Email address') }}</label>
                <div class="col-sm-12">
                  <div class="input-group">
                    <input type="text" class="form-control btn-rounded" id="email" v-model="userData.email">
                  </div>
                </div>
              </div>
              <div class="change-photo-div">
                <div class="row title-row">
                  <div class="col-12 col-sm-2">
                    <p class="photo-header">{{ $t("Your photo") }}</p>
                  </div>
                </div>
                <div class="row">
                  <div class="avatar-container">
                    <!-- TODO: test.achiev.eu weghalen-->
                    <img class="avatar-img" :src="picture">
                  </div>
                  <!--<div class="col-3 ml-auto center-buton-container">-->
                  <!--<button class="btn btn-link center-button">{{ $t("Remove photo") }}</button>-->
                  <!--</div>-->
                  <div class="col-3 mr-0 center-buton-container">
                    <div class="upload-wrapper">
                      <img src="../assets/img/loader.gif" v-show="uploadingImage">
                      <button class="btn btn-light btn-rounded center-button" onclick="document.getElementById('profile-picture-input').click()">
                        <template v-if="userData.photo.endsWith('user_photo_placeholder.svg')">{{ $t("Change photo") }}</template>
                        <template v-else>{{ $t("Upload photo") }}</template>
                      </button>
                      <input type="file" id="profile-picture-input" @change="changeProfilePicture($event.target.name, $event.target.files)"/>
                    </div>
                  </div>
                </div>
              </div>
              <hr>

              <ul class="button-list">
                <li class="button-item">
                  <button type="button" class="btn btn-sm btn-rounded btn-info" v-on:click="changeData">
                    {{ $t('Save changes') }}
                  </button>
                </li>
                <li class="button-item">
                  <div class="change-password-div">
                    <a v-on:click="changePassword">{{ $t('Change Password') }}</a>
                  </div>
                </li>
              </ul>
            </form>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-md-12 d-block d-sm-none">
        <div v-if="changingPassword" class="card">
          <div class="card-body">
            <div>
              <h3 class="card-title">{{ $t('Change Password') }}</h3>
            </div>

            <div class="form-group row">
              <label for="newpwmobile" class="col-sm-12 control-label">{{ $t('New password') }}</label>
              <div class="col-sm-12">
                <div class="input-group">
                  <input type="password" class="form-control btn-rounded" id="newpwmobile" placeholder="" v-model="password">
                </div>
                <small class="text-danger">{{ passwordError }}</small>
              </div>
            </div>

            <div class="form-group row">
              <label for="pwcnfmobile" class="col-sm-12 control-label">{{ $t('Retype new password') }}</label>
              <div class="col-sm-12">
                <div class="input-group">
                  <input type="password" class="form-control btn-rounded" id="pwcnfmobile" placeholder="" v-model="passwordconf">
                </div>
                <small class="text-danger">{{ passwordError }}</small>
              </div>
            </div>

            <ul class="button-list">
              <li class="button-item">
                <div>
                  <button class="btn btn-sm btn-rounded btn-info" v-on:click="submitNewPassword">{{ $t('Change password') }}</button>
                </div>
              </li>
              <li class="button-item">
                <div class="cancel-button">
                  <a v-on:click="cancel">{{ $t('Cancel') }}</a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>


      <div class="col-lg-6 col-md-12">
        <div class="card">
          <div class="card-body">
            <div>
              <h3 class="card-title">{{ $t('Settings') }}</h3>
            </div>

            <form class="form-horizontal p-t-20">
              <div class="form-group row m-b-0">
                <label for="language" class="col-sm-12 control-label">{{ $t('Language') }}</label>
                <div class="offset-sm-6 col-sm-6">
                  <div class="input-group">
                    <select class="form-control btn-rounded" id="language" v-model="language" v-on:change="changeLanguage">
                      <option v-for="lang in languages" :value="lang.code" >{{ lang.name }}</option>
                    </select>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <div>
              <h3 class="card-title">{{ $t('My Units & Roles') }}</h3>
            </div>

            <p>{{ $t('Your role is ') }} {{ userData.position }}</p>

            <p>
              {{ $t('and you are a member of the following units:') }}
            </p>
            <ul>
              <li v-for="unit in userData.Orgunits.data">
                <b>{{ unit.Orgunit.data.name }}</b> <small>{{ unit.UserRole.data.name }}</small>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="row d-none d-sm-block">
      <div class="col-lg-6 col-md-12">
        <div v-if="changingPassword" class="card">
          <div class="card-body">
            <div>
              <h3 class="card-title">{{ $t('Change Password') }}</h3>
            </div>

            <div class="form-group row">
              <label for="newpw" class="col-sm-12 control-label">{{ $t('New password') }}</label>
              <div class="col-sm-12">
                <div class="input-group">
                  <input type="password" class="form-control btn-rounded" id="newpw" placeholder="" v-model="password">
                </div>
                <small class="text-danger">{{ passwordError }}</small>
              </div>
            </div>

            <div class="form-group row">
              <label for="pwcnf" class="col-sm-12 control-label">{{ $t('Retype new password') }}</label>
              <div class="col-sm-12">
                <div class="input-group">
                  <input type="password" class="form-control btn-rounded" id="pwcnf" placeholder="" v-model="passwordconf">
                </div>
                <small class="text-danger">{{ passwordError }}</small>
              </div>
            </div>

            <ul class="button-list">
              <li class="button-item">
                <div>
                  <button class="btn btn-sm btn-rounded btn-info" v-on:click="submitNewPassword">{{ $t('Change password') }}</button>
                </div>
              </li>
              <li class="button-item">
                <div class="cancel-button">
                  <a v-on:click="cancel">{{ $t('Cancel') }}</a>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import APIHelper from '../mixins/APIHelper';
  export default {
    name: "profile",
    data: function() {
      return {
        userData: {},
        etag: '',
        oldpassword: '',
        password: '',
        passwordconf: '',
        language: 'en',
        languages: [
          {
            name: 'English',
            code: 'en'
          },
          {
            name: 'Dutch',
            code: 'nl'
          },
          {
            name: 'German',
            code: 'de'
          },
          {
            name: 'French',
            code: 'fr'
          },
          {
            name: 'Italian',
            code: 'it'
          },
          {
            name: 'Porgugese',
            code: 'pt'
          },
          {
            name: 'Spanish',
            code: 'es'
          },
          {
            name: 'Chinese',
            code: 'cn'
          }
        ],
        changingPassword: false,
        passwordError: "",
        profilePicture: {},
        pictureUploaded: false,
        picture: "",
        uploadingImage: false
      }
    },
    created() {
      let vm = this;
      let userId = localStorage.getItem("user_uid");
      let token = localStorage.getItem("achiev_token");
      vm.picture = APIHelper.getUserData().photo;

      fetch(__API__ + "/api/user/" + userId + "?include=Orgunits", {
        headers: {
          Authorization: "Bearer " + token
        }
      }).then((response) => {
        vm.etag = response.headers.get("etag");
        vm.etag = vm.etag.substr(0, vm.etag.length - 6) + '"';

        return response.json();
      }).then((data) => {
        vm.userData = data.data;
      });
      let settings = this.$parent.user.Settings.data;

      for(let setting in settings){
        if(settings[setting].setting === "language"){
          this.language = settings[setting].value;
          this.$root.$i18n.locale = this.language;
        }
      }
    },
    methods: {
      changeLanguage: function(){
        let vm = this;
        this.$root.$i18n.locale = this.language;
        APIHelper.putResource("/api/user/{uid}/settings/language", {
          "value": this.language
        }).then(function (data) {
          if(data === true){
            vm.$notify({
              group: "notification",
              title: "Success",
              text: vm.$t("Language changed successfully"),
              type: 'success'
            });
          }
        });

        let settings = this.$parent.user.Settings.data;

        for(let setting in settings){
          if(settings[setting].setting === "language"){
            settings[setting].value = this.language;
          }
        }
        APIHelper.setUserData(this.$parent.user);
      },
      changePassword: function() {
        this.changingPassword = !this.changingPassword;
      },
      cancel: function() {
        this.changingPassword = false;
        this.oldpassword = '';
        this.password = '';
        this.passwordconf = '';
      },
      changeProfilePicture: function(name, files){
        let vm = this;
        let formData = new FormData();
        vm.uploadingImage = true;
        formData.append('file', files[0]);

        APIHelper.postFile("/api/user/{uid}/profile-picture", formData).then((data) => {
          vm.picture = data.data.photo;
          vm.$parent.user.photo = data.data.photo;
          APIHelper.setUserData(this.$parent.user);
          vm.$notify({
            group: "notification",
            title: vm.$t("Success"),
            text: vm.$t("Photo updated successfully"),
            type: 'success'
          });
          vm.uploadingImage = false;
        });
      },
      changeData: function () {
        let vm = this;
        let token = localStorage.getItem("achiev_token");
        let userId = localStorage.getItem("user_uid");
        this.$parent.user.firstname = this.userData.firstname;
        this.$parent.user.lastname = this.userData.lastname;
        this.$parent.user.email = this.userData.email;
        APIHelper.setUserData(this.$parent.user);

        fetch(__API__ + "/api/user/" + userId, {
          body: JSON.stringify(vm.userData),
          method: "PUT",
          headers: {
            Authorization: "Bearer " + token,
            'content-type': 'application/json',
            'If-Match': vm.etag
          }
        }).then((response) => {
          if(response.status === 200){
            vm.etag = response.headers.get("etag");
            vm.etag = vm.etag.substr(0, vm.etag.length - 6) + '"';
            return response.json()
          }
        }).then((data) => {
          this.$notify({
            group: "notification",
            title: "Success",
            text: vm.$t("User data updated successfully"),
            type: 'success'
          })
        })
      },
      submitNewPassword: function () {
        let vm = this;
        if(this.password.length < 6){
          vm.passwordError = vm.$t("Password must be longer than 6 characters");
          return;
        }
        if (this.password === this.passwordconf) {
          vm.passwordError = "";
          let etag = "";
          let headers = {
            Authorization: "Bearer " + localStorage.getItem("achiev_token"),
            'content-type': 'application/json',
            'cache-control': 'no-store',
            'pragma': 'no-cache'

          };
          fetch(__API__ + "/api/user/" + vm.userData.uid,
            {
              method: "GET",
              mode: "cors",
              headers: headers,
              credentials: "include",
            })
            .then((response) => {
              etag = response.headers.get("etag").slice(0, -6) + '"';
              return response.json();
            })
            .then((data) =>{

              let data_to_send = {
                "firstname": vm.userData.firstname,
                "lastname": vm.userData.lastname,
                "phone": vm.userData.phone,
                "position": vm.userData.position,
                "photo": "",
                "credentials": 1,
                "email": vm.userData.email,
                "password": this.password
              };
              let headers = {
                Authorization: "Bearer " + localStorage.getItem("achiev_token"),
                'content-type': 'application/json',
                'If-Match': etag
              };

              fetch(__API__ + "/api/user/" + vm.userData.uid, {
                body: JSON.stringify(data_to_send),
                method: "PUT",
                headers: headers
              })
                .then((response) => {
                  return response.json();
                })
                .then((data) => {
                  if(typeof data.status !== 'undefined' && data.status === 409){
                    vm.passwordError = vm.$t("Password does not meet the requirements")
                  }else{
                    vm.$notify({
                      group: "notification",
                      title: "Success",
                      text: vm.$t("Password changed successfully"),
                      type: 'success'
                    });
                    vm.password = "";
                    vm.passwordconf = "";
                  }
                })
            });

        } else {
          vm.passwordError = vm.$t("The passwords don't match");
        }
      }
    }
  }
</script>

<style scoped>
  .form-group small{
    padding-left: 20px;
  }

  .avatar-img{
    display: inline-block;
    width: 150px;
    height: 150px;
    border-radius: 50%;
    margin-left: 20px;

    object-fit: cover;
  }
  .center-buton-container{
    position: relative;
  }
  .center-buton-container > .center-button, .center-buton-container > .upload-wrapper{
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
  }

  .change-photo-div{
    margin-top: 10px;
    margin-bottom: 25px;
  }

  .change-photo-div button{
    color: #1bb5eb;
  }

  .title-row{
    margin-bottom: 10px;
  }
  .btn-light{
    border: lightgrey 1px solid;
  }

  .change-password-div{
    padding-top: 15px;
  }

  .upload-wrapper {
    position: relative;
    overflow: hidden;
    display: inline-block;
    cursor: pointer;
  }
  .upload-wrapper *{
    cursor: pointer;
  }

  .upload-wrapper input[type=file] {
    font-size: 0 !important;
    position: absolute;
    left: 0;
    top: 0;
    opacity: 0;
    cursor: pointer !important;
  }

  .cancel-button{
    margin-top: 15px;
  }

  .form-group > .col-sm-6:not(:last-child){
    margin-bottom: 25px;
  }

  @media (max-width: 768px) {
    .avatar-img{
      height: 50px;
      width: 50px;
    }
    .ml-auto{
      margin-left: 0px !important;
    }

    .photo-header{
      font-weight: 600;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Profile.vue